"use strict";
/* eslint-disable functional/no-class */
// Eslint doesn't know how to handle the Map from Immutable.
/* eslint-disable functional/prefer-readonly-type */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInitialState = exports.stateKeys = void 0;
const immutable_1 = require("immutable");
const monet_1 = require("monet");
const ramda_1 = require("ramda");
const locale_1 = require("../commercetools/locale");
const config_1 = require("../config");
exports.stateKeys = {
    activePromotion: 'activePromotion',
    cart: 'cart',
    contactForm: 'contactForm',
    currentPromotion: 'currentPromotion',
    evergreenPromotion: 'evergreenPromotion',
    locale: 'locale',
    minicart: 'minicart',
    navigationProductCategory: 'navigationProductCategory',
    numberOfFreeMonthsOfService: 'numberOfFreeMonthsOfService',
    packages: 'packages',
    partnerBanner: 'partnerBanner',
    partnerWithUsForm: 'partnerWithUsForm',
    policeData: 'policeData',
    products: 'products',
    promotions: 'promotions'
};
const defaultValues = {
    error: monet_1.Maybe.None(),
    loading: true
};
const stateRecordFactory = (0, immutable_1.Record)({
    [exports.stateKeys.cart]: {
        ...defaultValues,
        loading: false,
        value: monet_1.Maybe.None()
    },
    [exports.stateKeys.locale]: {
        currencyCode: (0, ramda_1.prop)('currency', locale_1.LOCALE_INFO) || 'GBP',
        locale: config_1.locale || 'en-GB',
    },
    [exports.stateKeys.navigationProductCategory]: {
        value: 'SHOW ALL',
        ...defaultValues
    },
    [exports.stateKeys.numberOfFreeMonthsOfService]: {
        value: 1,
        ...defaultValues
    },
    [exports.stateKeys.packages]: {
        value: (0, immutable_1.Map)(),
        ...defaultValues
    },
    [exports.stateKeys.policeData]: {
        value: {
            geoLocation: {
                attribution: '',
                features: [],
                query: [],
                type: ''
            },
            locations: {}
        },
        ...defaultValues
    },
    [exports.stateKeys.contactForm]: {
        value: {
            messageId: '',
            status: ''
        },
        ...defaultValues
    },
    [exports.stateKeys.products]: {
        value: (0, immutable_1.Map)(),
        ...defaultValues
    },
    [exports.stateKeys.minicart]: {
        value: {},
        ...defaultValues
    },
    [exports.stateKeys.partnerWithUsForm]: {
        submitted: false,
        value: {
            email: '',
            leadId: '',
            leadSource: '',
            message: '',
            returnCode: ''
        },
        ...defaultValues
    },
    [exports.stateKeys.evergreenPromotion]: {
        ...defaultValues,
        loading: false,
        value: (0, monet_1.None)()
    },
    [exports.stateKeys.activePromotion]: {
        ...defaultValues,
        loading: false,
        value: (0, monet_1.None)()
    },
    [exports.stateKeys.currentPromotion]: {
        ...defaultValues,
        loading: false,
        value: (0, monet_1.None)()
    },
    [exports.stateKeys.partnerBanner]: {
        ...defaultValues,
        loading: false,
        value: (0, monet_1.None)()
    },
    [exports.stateKeys.promotions]: (0, immutable_1.Map)()
});
/**
 * Create the initial store
 */
const createInitialState = (state) => {
    return stateRecordFactory(state);
};
exports.createInitialState = createInitialState;
//# sourceMappingURL=state.js.map